import IconNavbarFlipboard from "./icon-navbar-flipboard";

export default IconNavbarFlipboard;